import { render, staticRenderFns } from "./AddInfoNews.vue?vue&type=template&id=be22a21a&scoped=true&"
import script from "./AddInfoNews.vue?vue&type=script&lang=js&"
export * from "./AddInfoNews.vue?vue&type=script&lang=js&"
import style0 from "./AddInfoNews.vue?vue&type=style&index=0&id=be22a21a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be22a21a",
  null
  
)

export default component.exports